import { render } from "./SustainabilityJumpToNavItem.vue?vue&type=template&id=12dd208b&scoped=true"
import script from "./SustainabilityJumpToNavItem.vue?vue&type=script&lang=js"
export * from "./SustainabilityJumpToNavItem.vue?vue&type=script&lang=js"

import "./SustainabilityJumpToNavItem.vue?vue&type=style&index=0&id=12dd208b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dd208b"]])

export default __exports__